import api from '../api';

export const getActivities = async () => {
	const response = await api.get('/atividade');
	return response.data;
};

export const deleteActivity = async (id: number) => {
	const response = await api.delete(`atividade?id=${id}`);
	return response.data;
};

export const getProductionRoadmapProductsByFilters = async params => {
	const response = await api.get('/roteiroProducao/filtroRoteiroProducao', {
		params: {
			...params,
		},
	});
	return response.data;
};
